import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';

import { Modal } from 'react-bootstrap';

class CertificationSupplierEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      certification_supplier_id: '',
      anac_code: '',
      expiration_str: '',
      certification: '',
      returning_deadline: '',
      hour_value: '',
      address: '',
      city: '',
      province: '',
      contact_name: '',
      phone: '',
      email: '',
      observations: '',
      supplier_id: '',
      certification_id: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.editCertificationSupplier = this.editCertificationSupplier.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_certification_supplier.id !== 'undefined') {
        this.setState({
          anac_code: newProps.data_certification_supplier.anac_code,
          expiration_str: newProps.data_certification_supplier.expiration_str,
          certification: newProps.data_certification_supplier.certification,
          returning_deadline: newProps.data_certification_supplier.returning_deadline,
          hour_value: newProps.data_certification_supplier.hour_value,
          contact_name: newProps.data_certification_supplier.contact_name,
          phone: newProps.data_certification_supplier.phone,
          email: newProps.data_certification_supplier.email,
          observations: newProps.data_certification_supplier.observations,
          id: newProps.data_certification_supplier.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  editCertificationSupplier(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      anac_code: this.state.anac_code,
      expiration: this.state.expiration_str,
      certification: this.state.certification,
      returning_deadline: this.state.returning_deadline,
      hour_value: this.state.hour_value,
      contact_name: this.state.contact_name,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/fornecedor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Editar certificado/fornecedor</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editCertificationSupplier}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Certificação:</label>
                    <input type="text" name="certification" className="form-control" placeholder="" value={this.state.certification} onChange={this.handleChange.bind(this, 'certification')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Código ANAC:</label>
                    <input type="text" name="anac_code" className="form-control" placeholder="" value={this.state.anac_code} onChange={this.handleChange.bind(this, 'anac_code')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Expiração:</label>
                    <InputMask value={this.state.expiration_str}  maskChar={null} name="expiration_str" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration_str')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Valor Hora:</label>
                    <InputMask value={this.state.hour_value}  maskChar={null} name="hour_value" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Prazo para Cancelamento com Retorno do Pagamento (em dias):</label>
                    <InputMask value={this.state.returning_deadline}  maskChar={null} name="returning_deadline" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'returning_deadline')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contato nome:</label>
                    <input type="text" name="contact_name" className="form-control" placeholder="" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Telefone:</label>
                    <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do fornecedor" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>E-mail:</label>
                    <input type="text" name="email" className="form-control" placeholder="E-mail do fornecedor" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Observações:</label>
                    <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar fornecedor</button>
                </div>
              </div>
            </form>    
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default CertificationSupplierEditModal;



// WEBPACK FOOTER //
// ./src/Components/CertificationSuppliers/Elements/CertificationSupplierEditModal.js